import React from 'react';
import { connect } from 'react-redux';
import DocumentList from './DocumentList';
import runtimeConfig from '../../../../config/runtimeConfig';
import { searchDocs } from '../../../../actions/InfoActions';
import { containerSelector } from './selectors';

const mapStateToProps = containerSelector;
const mapDispatchToProps = dispatch => ({
    init: () => dispatch(searchDocs({ count: runtimeConfig.itemsCountPerPage, page: 1 })),
    search: params => dispatch(searchDocs({...params, count: runtimeConfig.itemsCountPerPage}))
});

const DocumentListContainer = connect(mapStateToProps, mapDispatchToProps)(DocumentList);

export default DocumentListContainer;
